import { render, staticRenderFns } from "./informacionedicion_reportesemanal.vue?vue&type=template&id=2b201a0c"
import script from "./informacionedicion_reportesemanal.vue?vue&type=script&lang=js"
export * from "./informacionedicion_reportesemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports